import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Ticket.scss";
import {
  Popup,
  TextBox,
  HtmlEditor,
  SelectBox,
  RadioGroup,
  Button,
  LoadPanel,
  DateBox,
  TagBox,
  Tooltip,
} from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import DataGrid, {
  Column,
  Export,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import { SubText } from "../../components/typographyText/TypographyText";
import {
  getTicketsApi,
  getCustTicketsApi,
  getcustcategory,
  postSaveTicket,
  getPriorityApi,
  getStatusApi,
} from "../../api/ticketApi";
import { getAllStatus } from "../../api/settingsApi";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { useAuth } from "../../contexts/auth";
import { getTicketTypes } from "../../api/typeOfQueryTicket";
import {
  fetchContactsByCustomerId,
  fetchCustomerContacts,
  fetchCustomerData,
} from "../../api/companyCustomerApi";
import { useTags } from "../../contexts/tagContext";
import { fetchUsers } from "../../api/companyUserApi";
import { filterTicketsApi } from "../../api/filterAPI";
import { statusColors } from "./detailTicketPage/DetailTicketPage";
import { Background } from "devextreme-react/range-selector";
import { sortTicketData } from "./data";
import DropDownBox from "devextreme-react/drop-down-box";
import TreeView from "devextreme-react/tree-view";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { exportDataGrid } from "devextreme/excel_exporter";

export default function Ticket() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { tagList, fetchTags } = useTags();
  const ticketdataGridRef = useRef(null);
  const updatedTicketGridRef = useRef(null);
  const [ticketDataSource, setTicketDataSource] = useState();
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [createTicketPopup, showCreateTicketPopup] = useState();
  const [displayedTicketCount, setDisplayedTicketCount] = useState(0);
  const [toggleWorkHrs, setToggleWorkHrs] = useState(false);
  const [custOptions, setCustOptions] = useState(false);
  const [contactOptions, setContactOptions] = useState([]);
  const [contactsByCompany, setContactsByCompany] = useState([]);
  const [filteredCount, setFilteredCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All Status");
  const [selectedUser, setSelectedUser] = useState("All User");
  const [priorityList, setPriorityList] = useState("");
  const isCustomer = user?.userrole === "customer";
  const isCompany = user?.userrole === "company";
  const isCompanyUser = user?.userrole === "companyuser";
  const isCustomerContact = user?.userrole === "customercontact";
  const showCustomerSelect = isCompany || isCompanyUser;
  const showContactSelect = isCustomer || isCompany || isCompanyUser;
  const [statusDataSource, setStatusDataSource] = useState([
    // { value: "All Status", text: "All Status" },
  ]);
  const fileInputRef = useRef(null);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectedCustFilter, setSelectedCustFilter] = useState("0");

  const [customerId, setCustomerId] = useState(
    user?.userrole === "customer" || user?.userrole === "customercontact"
      ? user?.customertransid
      : "",
  );

  const [onlyMyTickets, setOnlyMyTickets] = useState(false);
  const [tagFilter, setTagFilter] = useState("");

  const [tempStatus, setTempStatus] = useState("0");
  const [tempUser, setTempUser] = useState("0");
  const [tempOnlyMyTickets, setTempOnlyMyTickets] = useState(false);
  const [tempTag, setTempTag] = useState("0");
  const [tempPriority, setTempPriority] = useState("0");
  const [ticketWf, setTicketWf] = useState("0");
  const [typeOfTicket, setTypeOfTicket] = useState("0");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [timeRange, setTimeRange] = useState(null);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const hasFocusedRef = useRef(false);
  const [selectedSort, setSelectedSort] = useState("");
  const [sortConfig, setSortConfig] = useState({
    field: "update_date",
    order: "desc",
  });

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const totalPages = Math.ceil(totalCount / pageSize);
  const [isFilterMode, setIsFilterMode] = useState(false);

  const isMobile = window.innerWidth < 768;

  const [showFilterPanel, setShowFilterPanel] = useState(!isMobile);
  const [typeList, setTypeList] = useState([]);
  const [customerList, setCustomerList] = useState();
  const [ticketForm, setTicketForm] = useState({
    subject: "",
    description: "",
    priority: "",
    category: "",
    subcategory: "",
    customer: "",
    contact: "",
    type: "",
    tags: [],
  });
  const MAX_TOTAL_SIZE = 25 * 1024 * 1024; // 25 MB

  const ALLOWED_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".png",
    ".pdf",
    ".doc",
    ".docx",
    ".txt",
    ".xlsx",
    ".mp4",
  ];
  const ticketTypeOptions = React.useMemo(() => {
    const mapped = typeList.map((item) => ({
      value: item.transid.toString(), // normalize
      text: item.tickettypename,
    }));

    return [
      { value: "0", text: "All" }, //  add this
      ...mapped,
    ];
  }, [typeList]);

  const ticketTypeOptionsCn = React.useMemo(() => {
    const mapped = typeList.map((item) => ({
      value: item.transid.toString(), // normalize
      text: item.tickettypename,
    }));

    return [...mapped];
  }, [typeList]);

  const tagOptions = React.useMemo(() => {
    if (!tagList) return [];

    const mapped = tagList.map((tag) => ({
      value: tag.tagid.toString(), //  normalize
      text: tag.tagname,
    }));

    return [
      { value: "0", text: "All" }, //  add this
      ...mapped,
    ];
  }, [tagList]);

  //FETCH
  const fetchPriorities = async () => {
    try {
      setLoading(true);
      const data = await getPriorityApi();
      setPriorityList(data);
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch priorities.",
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusList = async () => {
    try {
      const res = await getAllStatus();

      const formatted = res.map((item) => ({
        text: item.name,
        value: item.id.toString(),
        color: item.color_code,
        roles: item.allowed_roles,
      }));

      setStatusList(formatted);
    } catch (error) {
      console.error("Failed to fetch status list", error);
    }
  };
  useEffect(() => {
    fetchPriorities();
    fetchStatusList();
  }, []);

  const editorRef = useRef(null);
  const [agentOptions, setAgentOptions] = useState([
    { value: "0", text: "All" },
  ]);
  const loadAgents = async () => {
    try {
      const res = await fetchUsers(user?.companytransid);

      if (res?.data) {
        const agents = res.data.map((u) => ({
          value: u.transid.toString(),
          text: u.cmpuserusername,
        }));

        setAgentOptions([{ value: "0", text: "All" }, ...agents]);
      }
    } catch (error) {
      ToastDisplayer("error", "Failed to load agents");
    }
  };

  useEffect(() => {
    if (user?.companytransid) {
      loadAgents();
    }
  }, [user]);

  useEffect(() => {
    if (createTicketPopup) {
      fetchTags(); // refresh tags when popup opens
    }
  }, [createTicketPopup]);

  // refresh categories when popup opens
  useEffect(() => {
    if (createTicketPopup && customerId) {
      fetchCategories();
    }
  }, [createTicketPopup, customerId]);

  const handleFileUploadClick = () => {
    fileInputRef?.current?.click();
  };

  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   if (!files.length) return;

  //   setAttachedFiles((prevFiles) => [...prevFiles, ...files]);

  //   // reset input so same file can be selected again
  //   e.target.value = "";
  // };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    let validFiles = [];

    for (let file of files) {
      const fileExt = "." + file.name.split(".").pop().toLowerCase();

      if (!ALLOWED_EXTENSIONS.includes(fileExt)) {
        ToastDisplayer("error", `${file.name} is not a supported file type`);
        continue;
      }

      validFiles.push(file);
    }

    if (validFiles.length === 0) {
      e.target.value = "";
      return;
    }

    // calculate total size
    const existingSize = attachedFiles.reduce(
      (sum, file) => sum + file.size,
      0,
    );

    const newFilesSize = validFiles.reduce((sum, file) => sum + file.size, 0);

    if (existingSize + newFilesSize > MAX_TOTAL_SIZE) {
      ToastDisplayer("error", "Total attachment size cannot exceed 25 MB");
      e.target.value = "";
      return;
    }

    setAttachedFiles((prev) => [...prev, ...validFiles]);

    // reset input so same file can be selected again
    e.target.value = "";
  };

  const removeFile = (index) => {
    setAttachedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const fetchTicketTypes = async () => {
    try {
      setLoading(true);

      const res = await getTicketTypes();

      if (res.success) {
        setTypeList(res.data || []);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch ticket types.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicketTypes();
    if (showCustomerSelect) {
      loadCustomerData();
    }
  }, []);
  const getPriorityColor = (name) => {
    switch (name.toLowerCase()) {
      case "low":
        return "#d4a500";
      case "medium":
        return "#2f6bd8";
      case "high":
        return "#d93025";
      case "urgent":
        return "#8b0000";
      case "important":
        return "#ff6f00";
      default:
        return "#999";
    }
  };

  const priorityOptions = React.useMemo(() => {
    if (!priorityList || priorityList.length === 0) return [];

    const mapped = priorityList.map((item) => ({
      value: item.id.toString(), // normalize to string
      text: item.name,
      color: getPriorityColor(item.name), // optional
    }));

    return [{ value: "0", text: "All", color: "#2700d4" }, ...mapped];
  }, [priorityList]);

  const priorityOptionCn = React.useMemo(() => {
    if (!priorityList || priorityList.length === 0) return [];

    const mapped = priorityList.map((item) => ({
      value: item.id.toString(), // normalize to string
      text: item.name,
      color: getPriorityColor(item.name), // optional
    }));

    return [...mapped];
  }, [priorityList]);

  const ticketWfOption = [
    { text: "All", value: "0", color: "#2700d4" },
    { text: "New", value: "New", color: "#5abf01" },
    { text: "Not assigned", value: "Not_Assigned", color: "#2f6bd8" },
    { text: "Overdue", value: "Overdue", color: "#d93025" },
  ];

  const renderPriorityItem = (data) => {
    if (!data) return <span>Select Priority</span>;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: data.color,
          }}
        />
        <span>{data.text}</span>
      </div>
    );
  };

  const renderPriorityButton = () => {
    const selected = priorityOptions.find(
      (p) => p.value === ticketForm.priority,
    );

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            backgroundColor: selected?.color || "#ccc",
          }}
        />
        <i className="dx-icon dx-icon-chevron-down" />
      </div>
    );
  };

  const handleChange = (field, value) => {
    if (field === "customer") {
      setCustomerId(value);
    }
    setTicketForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [filteredSubcategories, setFilteredSubcategories] = useState([]);

  const loadCustomerData = async () => {
    try {
      setLoading(true);

      const res = await fetchCustomerData(user?.companytransid);

      setCustOptions(
        res.data?.filter((data) => data?.custstatus === "active") || [],
      );
      setCustomerList(res.data);
    } catch (err) {
      ToastDisplayer(
        "error",
        err.response?.data?.error ||
          err.response?.data?.detail ||
          err.response?.data?.code,
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchContactsByCustomer = async () => {
    if (!customerId) return;
    try {
      const res = await fetchContactsByCustomerId(customerId);
      setContactsByCompany(
        res?.data?.contacts?.filter((data) => data?.status === "Active"),
      );
    } catch (error) {
      ToastDisplayer("error", "Failed to fetch contacts");
    }
  };

  useEffect(() => {
    if (!createTicketPopup) return;

    if (showCustomerSelect) {
      loadCustomerData();
    }
  }, [createTicketPopup]);

  useEffect(() => {
    if (!createTicketPopup) return;
    if (!customerId) return;

    fetchContactsByCustomer();
  }, [createTicketPopup, customerId]);

  const fetchCategories = async () => {
    try {
      const res = await getcustcategory(user?.companytransid, customerId);

      const mappedCategories = res.category_subcategory_mappings.map((cat) => ({
        value: cat.category_id,
        text: cat.category_name,
        subcategories: (cat.subcategories || []).map((sub) => ({
          value: sub.subcategory_id,
          text: sub.subcategory_name,
        })),
      }));

      setCategoryOptions(mappedCategories);
    } catch (error) {
      ToastDisplayer("error", "Failed to fetch categories");
    }
  };

  useEffect(() => {
    if (customerId) {
      fetchCategories();
    }
  }, [customerId]);

  useEffect(() => {
    if (ticketForm.category) {
      const selectedCategory = categoryOptions.find(
        (cat) => cat.value === ticketForm.category,
      );

      if (selectedCategory) {
        setFilteredSubcategories(selectedCategory.subcategories);
      } else {
        setFilteredSubcategories([]);
      }
    }
  }, [ticketForm.category, categoryOptions]);

  const resetTicketForm = async () => {
    setTicketForm({
      subject: "",
      description: "",
      priority: "",
      category: "",
      subcategory: "",
      customer: "",
      contact: "",
      type: "",
      tags: [],
    });

    setAttachedFiles([]);
    setFilteredSubcategories([]);

    try {
      // if (
      //   user?.userrole === "customer" ||
      //   user?.userrole === "customercontact"
      // ) {
      //   await fetchCustomerTickets();
      // } else {
      await fetchTickets();
      // }
    } catch (error) {
      console.error("Error refreshing tickets:", error);
    }
  };

  const handleCreateTicketClosePopup = () => {
    showCreateTicketPopup(false);
    editorRef.current?.instance?.option("value", "");
    setAttachedFiles([]);
  };

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const isDescriptionEmpty = (html) => {
    if (!html) return true;

    const temp = document.createElement("div");
    temp.innerHTML = html;

    const text = temp.textContent || temp.innerText || "";

    return text.trim().length === 0;
  };

  const handleCreateTicket = async () => {
    try {
      const description = editorRef.current?.instance?.option("value") || "";
      const missingFields = [];

      if (!ticketForm.subject) missingFields.push("Subject");
      if (isDescriptionEmpty(description)) missingFields.push("Description");
      if (!ticketForm.priority) missingFields.push("Priority");
      if (!ticketForm.category) missingFields.push("Category");
      if (!ticketForm.subcategory) missingFields.push("Subcategory");

      if (missingFields.length > 0) {
        ToastDisplayer("error", `Please fill: ${missingFields.join(", ")}`);
        return;
      }
      let attachments = [];

      if (attachedFiles?.length > 0) {
        attachments = await Promise.all(
          attachedFiles.map(async (file) => {
            const base64 = await convertFileToBase64(file);

            return {
              filename: file.name,
              filedata: base64.split(",")[1], // remove data:mime;base64,
            };
          }),
        );
      }
      setLoading(true);

      const payload = {
        ticketsubject: ticketForm.subject,
        ticketdescription: description,
        ticketcategorytransid: ticketForm.category,
        ticketsubcattransid: ticketForm.subcategory,
        ticketpriority_fk: ticketForm.priority,
        tickettype: ticketForm.type,
        tags: ticketForm.tags || [],
        attachments: attachments,
      };

      if (isCompany || isCompanyUser) {
        payload.customertransid = customerId;
        payload.contacttransid = ticketForm.contact;
      }

      if (isCustomer) {
        payload.contacttransid = ticketForm.contact;
      }

      await postSaveTicket(payload);

      // REMOVE last opened ticket
      sessionStorage.removeItem("lastOpenedTicket");
      hasFocusedRef.current = false;

      ToastDisplayer("success", "Ticket created successfully");

      showCreateTicketPopup(false);
      resetTicketForm();
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error || "Failed to create ticket",
      );
    } finally {
      setLoading(false);
    }
  };

  const filteredTickets = React.useMemo(() => {
    if (!ticketDataSource) return [];

    const today = new Date();

    const checkDateRange = (dateString, days) => {
      if (!dateString) return true;

      const date = new Date(dateString);
      const diffDays = (today - date) / (1000 * 60 * 60 * 24);

      return diffDays <= Number(days);
    };

    return ticketDataSource;
  }, [ticketDataSource]);

  const formatLocalDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const applyFilters = async () => {
    sessionStorage.removeItem("ticketNavSource");
    sessionStorage.removeItem("lastOpenedTicket");
    hasFocusedRef.current = false;

    try {
      setLoading(true);

      const params = {};
      if (selectedCustFilter !== "0") {
        params.customer_id = selectedCustFilter;
      }

      if (tempStatus !== "0") {
        params.status = tempStatus;
      }
      if (timeRange !== "0") {
        params.time_range = timeRange; //add hrs value
      }
      if (tempPriority !== "0") {
        params.ticketpriority_fk = tempPriority;
      }
      if (tempUser !== "0") params.assigned_user = tempUser;
      if (typeOfTicket !== "0") params.tickettype = typeOfTicket;
      if (ticketWf !== "0") {
        params.ticketworkflow = ticketWf;
      }
      if (tempOnlyMyTickets) params.created_by_me = true;
      // if (tempClosedFilter !== "none") params.closed_range = tempClosedFilter;
      // if (tempCreatedFilter !== "none") params.open_range = tempCreatedFilter;
      if (tempTag !== "0") {
        params.tag_id = tempTag;
      }

      // Add Date Filters
      if (fromDate) {
        params.from_date = formatLocalDate(fromDate);
      }

      if (toDate) {
        params.to_date = formatLocalDate(toDate);
      }
      const res = await filterTicketsApi(params);

      if (res.success) {
        const tickets = res.data?.tickets || [];

        const formattedData = tickets.map((ticket) => {
          if (ticket.entry_date) {
            const dateObj = new Date(ticket.entry_date);

            ticket.entry_date_obj = dateObj;

            ticket.entry_date = `${dateObj
              .getDate()
              .toString()
              .padStart(2, "0")}/${(dateObj.getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${dateObj.getFullYear()} ${
              dateObj.toTimeString().split(" ")[0]
            }`;
          }

          return ticket;
        });

        setTicketDataSource(formattedData.reverse());
        setDisplayedTicketCount(res.data.count || formattedData?.length);
      }
      setIsFilterMode(true);
      setPageIndex(0);

      setTimeout(() => {
        const grid = updatedTicketGridRef.current?.instance;
        grid?.pageSize(pageSize);
        grid?.pageIndex(0);
      }, 0);

      // setTimeout(() => {
      //      updatedTicketGridRef.current?.instance?.pageIndex(0);
      //   }, 0);

      // setShowFilterPanel(false); don't hide filters on apply
    } catch (error) {
      ToastDisplayer("error", "Failed to apply filters");
    } finally {
      setLoading(false);
    }
  };
  const isApplyEnabled =
    tempStatus !== "0" ||
    tempUser !== "0" ||
    tempPriority !== "0" ||
    tempTag !== "0" ||
    tempOnlyMyTickets ||
    ticketWf !== "0" ||
    typeOfTicket !== "0" ||
    selectedCustFilter !== "0" ||
    fromDate !== null ||
    toDate !== null ||
    timeRange !== null;

  const resetFilters = () => {
    // setTempCreatedFilter("30d");
    // setTempClosedFilter("none");
    setTempStatus("0");
    setTempUser("0");
    setTempOnlyMyTickets(false);
    setTempTag("0");
    setFromDate(null);
    setToDate(null);
    setTicketWf("0");
    setTypeOfTicket("0");
    setTimeRange(null);
    // setCreatedFilter("30");
    // setClosedFilter("none");
    setSelectedStatus("All Status");
    setSelectedUser("All User");
    setOnlyMyTickets(false);
    setTagFilter("");
    setTempPriority("0");
    setSelectedCustFilter("0");
    setIsFilterMode(false);
    setPageIndex(0);
    fetchTickets(0);
  };

  const calculateTotalWorkingTime = (timespent) => {
    if (!Array.isArray(timespent)) return "0 hrs 0 mins";

    let totalMinutes = 0;

    timespent.forEach((entry) => {
      if (!entry.starttime || !entry.endtime) return;

      const [startHours, startMinutes] = entry.starttime.split(":").map(Number);
      const [endHours, endMinutes] = entry.endtime.split(":").map(Number);

      let start = startHours * 60 + startMinutes; // Convert start time to minutes
      let end = endHours * 60 + endMinutes; // Convert end time to minutes

      if (end < start) {
        // If end time is on the next day
        end += 24 * 60; // Add 24 hours to end time
      }

      totalMinutes += end - start;
    });

    const hours = Math.floor(totalMinutes / 60);
    const minutes = (totalMinutes % 60).toFixed(2);

    return `${hours} hrs ${minutes} mins`;
  };

  const fetchTickets = async (page = pageIndex) => {
    try {
      setLoading(true);

      //  NEW: calculate offset
      const offset = page * pageSize;

      const ticketResult = await getTicketsApi(offset);
      console.log("ticketResult:", ticketResult);

      if (ticketResult.status !== 200) {
        throw new Error("Error fetching tickets");
      }
      console.log("apiData:", ticketResult.data);
      const apiData = ticketResult.data || [];
      console.log("apiData:", ticketResult.data);

      const formattedData = apiData.map((ticket) => {
        if (ticket.entry_date) {
          const dateObj = new Date(ticket.entry_date);
          ticket.entry_date_obj = dateObj;
          ticket.entry_date = `${dateObj
            .getDate()
            .toString()
            .padStart(2, "0")}/${(dateObj.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${dateObj.getFullYear()} ${
            dateObj.toTimeString().split(" ")[0]
          }`;
        }

        ticket.total_work_hours = calculateTotalWorkingTime(ticket.timespent);
        return ticket;
      });
      console.log("formattedData:", formattedData);

      //  KEEP SORTING
      formattedData.sort((a, b) => b.entry_date_obj - a.entry_date_obj);

      //  SET DATA
      setTicketDataSource(formattedData);

      //  NEW: total count for pagination
      const total = apiData.length > 0 ? apiData[0].total_count : 0;
      setTotalCount(total);

      //  KEEP STATUS LOGIC
      const uniqueStatuses = new Set();

      formattedData.forEach((ticket) => {
        if (ticket.ticketstatus_name) {
          uniqueStatuses.add(ticket.ticketstatus_name);
        }
      });

      const formattedStatusOptions = [
        { value: "All Status", text: "All Status" },
      ];

      uniqueStatuses.forEach((status) => {
        formattedStatusOptions.push({ value: status, text: status });
      });

      setStatusDataSource(formattedStatusOptions);

      //  KEEP USERS LOGIC (even if not used)
      const uniqueUsers = new Set();
      formattedData.forEach((ticket) => {
        if (ticket.working_user) {
          uniqueUsers.add(ticket.working_user);
        }
      });

      setDataLoaded(true);
      setIsFilterMode(false);
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error || "Error in fetching ticket data",
      );
      setDataLoaded(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isFilterMode) {
      fetchTickets(pageIndex);
    }
  }, [user, pageIndex, isFilterMode]);

  useEffect(() => {
    setDisplayedTicketCount(filteredTickets.length);
  }, [filteredTickets]);

  const handleCreateNew = () => {
    // if (user?.userrole === "customer" || user?.userrole === "customercontact") {
    //   showCreateTicketPopup(true);
    // } else {
    //   navigate("/ticket/Add-New");
    // }
    showCreateTicketPopup(true);
  };

  const renderDropDownButton = () => {
    const selected = statusOptions.find((s) => s.value === tempStatus);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            backgroundColor: selected?.color || "#ccc",
          }}
        />
        <i className="dx-icon dx-icon-chevron-down" />
      </div>
    );
  };

  const renderPriorityDropDownButton = () => {
    const selected = priorityOptions.find((p) => p.value === tempPriority);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            backgroundColor: selected?.color || "#ccc",
          }}
        />
        <i className="dx-icon dx-icon-chevron-down" />
      </div>
    );
  };

  const statusOptions = React.useMemo(() => {
    if (!statusList || statusList.length === 0) return [];

    return [
      { value: "0", text: "All", color: "#a0a6f2" },
      ...statusList.map((s) => ({
        value: s.value.toString(), // normalize to string
        text: s.text,
        color: s.color,
      })),
    ];
  }, [statusList]);
  const renderStatusItem = (data) => {
    if (!data) return <span>Select Status</span>;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: data.color,
            display: "inline-block",
          }}
        />

        <span>{data.text}</span>
      </div>
    );
  };
  const editorToolbarItems = React.useMemo(
    () => [
      { name: "bold" },
      { name: "italic" },
      { name: "underline" },
      {
        widget: "dxButton",
        options: {
          icon: "attach",
          hint: "Attach file",
          onClick: handleFileUploadClick,
        },
      },
      { name: "link" },
      { name: "orderedList" },
      { name: "bulletList" },
      { name: "codeBlock" },
    ],
    [],
  );

  const sortedTickets = React.useMemo(() => {
    if (!filteredTickets) return [];
    if (isFilterMode) {
      return filteredTickets;
    }

    //  guard condition
    if (!sortConfig || !sortConfig.field) {
      return filteredTickets;
    }

    return [...filteredTickets].sort((a, b) => {
      if (sortConfig.field === "ticketpriority_fk") {
        return sortConfig.order === "asc"
          ? (a.ticketpriority_fk || 0) - (b.ticketpriority_fk || 0)
          : (b.ticketpriority_fk || 0) - (a.ticketpriority_fk || 0);
      }

      if (sortConfig.field === "update_date") {
        const dateA = new Date(a.update_date || 0);
        const dateB = new Date(b.update_date || 0);
        return sortConfig.order === "asc" ? dateA - dateB : dateB - dateA;
      }

      if (sortConfig.field === "entry_date_obj") {
        const dateA = a.entry_date_obj?.getTime?.() || 0;
        const dateB = b.entry_date_obj?.getTime?.() || 0;
        return sortConfig.order === "asc" ? dateA - dateB : dateB - dateA;
      }

      return 0;
    });
  }, [filteredTickets, sortConfig]);

  const indexedTickets = React.useMemo(() => {
    return sortedTickets.map((ticket, index) => ({
      ...ticket,
      // srNo: sortedTickets.length - index,
      __key: ticket.transid,
    }));
  }, [sortedTickets]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [foundPage, setFoundPage] = useState(false);

  //navigate back to selected ticket
  useEffect(() => {
    if (!dataLoaded) return;
    if (!indexedTickets || indexedTickets.length === 0) return;
    if (hasFocusedRef.current) return;

    const lastTicketCode = sessionStorage.getItem("lastOpenedTicket");
    const navSource = sessionStorage.getItem("ticketNavSource");

    if (!lastTicketCode || navSource !== "details") return;

    // ✅ check using ticketcode
    const exists = indexedTickets.some((t) => t.ticketcode === lastTicketCode);

    if (!exists) {
      if (pageIndex < totalPages - 1) {
        setPageIndex((prev) => prev + 1);
      }
      return;
    }

    // ✅ found
    hasFocusedRef.current = true;
    setFoundPage(true);

    sessionStorage.removeItem("ticketNavSource");
  }, [indexedTickets]);

  const getRowClass = (ticketCode) => {
    const lastTicketCode = sessionStorage.getItem("lastOpenedTicket");
    return lastTicketCode === ticketCode ? "custom-highlight-row" : "";
  };

  //scroll back to last selected ticket
  useEffect(() => {
    if (!foundPage) return;

    let attempts = 0;

    const scrollToRow = () => {
      const el = document.querySelector(
        ".dx-data-row:has(.custom-highlight-row)",
      );

      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else if (attempts < 10) {
        attempts++;
        setTimeout(scrollToRow, 100); // retry
      }
    };

    scrollToRow();
  }, [foundPage]);

  const flatSortOptions = React.useMemo(() => {
    const result = [];

    sortTicketData.forEach((parent) => {
      parent.items?.forEach((child) => {
        result.push({
          id: child.id,
          text: `${parent.text} - ${child.text}`,
        });
      });
    });

    return result;
  }, []);
  const handleSortClick = (e) => {
    const item = e.itemData;

    //  Parent click → toggle manually
    if (item.items?.length) {
      setExpandedKeys((prev) => {
        if (prev.includes(item.id)) {
          e.component.collapseItem(item.id);
          return prev.filter((k) => k !== item.id);
        } else {
          e.component.expandItem(item.id);
          return [...prev, item.id];
        }
      });

      return;
    }

    //  Child → apply sorting
    setSelectedSort(item.id);
    setSortConfig({
      field: item.field,
      order: item.order,
    });

    sessionStorage.removeItem("ticketNavSource");
    sessionStorage.removeItem("lastOpenedTicket");
    hasFocusedRef.current = false;

    const grid = updatedTicketGridRef.current?.instance;
    if (grid) {
      grid.option("focusedRowKey", null);
      grid.option("focusedRowIndex", -1);

      // optional: scroll to top
      grid.getScrollable().scrollTo({ top: 0 });
    }

    e.component.selectItem(item.id);

    e.component._$element
      .closest(".dx-dropdownbox")
      ?.dxDropDownBox("instance")
      ?.close();
  };

  const handleSearch = async (value) => {
    setSearchText(value);

    if (!value) {
      setIsFilterMode(false);
      setPageIndex(0);
      fetchTickets(0);
      return;
    }

    try {
      setLoading(true);

      const params = {
        search: value, // 🔥 same like filter
      };

      const res = await filterTicketsApi(params);

      if (res.success) {
        const tickets = res.data?.tickets || [];

        const formattedData = tickets.map((ticket) => {
          if (ticket.entry_date) {
            const dateObj = new Date(ticket.entry_date);

            ticket.entry_date_obj = dateObj;

            ticket.entry_date = `${dateObj
              .getDate()
              .toString()
              .padStart(2, "0")}/${(dateObj.getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${dateObj.getFullYear()} ${
              dateObj.toTimeString().split(" ")[0]
            }`;
          }

          return ticket;
        });

        setTicketDataSource(formattedData.reverse());
        setDisplayedTicketCount(res.data.count || formattedData.length);
        setIsFilterMode(true);
        setPageIndex(0);

        setTimeout(() => {
          const grid = updatedTicketGridRef.current?.instance;
          grid?.pageSize(pageSize);
          grid?.pageIndex(0);
        }, 0);

        // setTimeout(() => {
        //    updatedTicketGridRef.current?.instance?.pageIndex(0);
        // }, 0);
      } else {
        setTicketDataSource([]);
      }
    } catch (error) {
      ToastDisplayer("error", "Search failed");
    } finally {
      setLoading(false);
    }
  };

  const debounceRef = useRef(null);

  const handleSearchDebounce = (value) => {
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      handleSearch(value);
    }, 400);
  };

  const onExporting = (e) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tickets");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      const now = new Date();

      const formattedDate = `${now.getFullYear()}-${String(
        now.getMonth() + 1,
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

      const fileName = `Tickets_${formattedDate}.xlsx`; //  dynamic name

      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          fileName,
        );
      });
    });

    e.cancel = true; // ❗ VERY IMPORTANT (stops default export)
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="ticketpage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span>
                <i class="ri-coupon-line"></i>
              </span>
              <p>All Ticket</p>
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              className="createBtn"
              icon="add"
              text="Create New"
              type="default"
              onClick={handleCreateNew}
            />
            {/* <Button
              text="Export"
              icon="export"
              stylingMode="outlined"
              type="default"
              width={120}
              onClick={handleExport}
            /> */}
            <Button
              text="Filter"
              icon="filter"
              stylingMode="outlined"
              type="default"
              width={120}
              className={showFilterPanel ? "filterBtnActive" : ""}
              onClick={() => setShowFilterPanel(!showFilterPanel)}
            />
          </div>
        </div>
        <div
          className={`ticketContainer middlePart  ${showFilterPanel ? "filterOpen" : ""}`}
          style={{ height: "calc(100vh - 180px)" }}
        >
          <div className="mainDatagrid">
            <DataGrid
              // selectedRowKeys={selectedRowKeys}
              // onSelectionChanged={(e) => {
              //   setSelectedRowKeys(e.selectedRowKeys);
              // }}
              renderAsync={false}
              repaintChangesOnly={true}
              dataSource={indexedTickets}
              className="ticketRowGrid"
              height={
                isFilterMode ? "calc(100vh - 188px)" : "calc(100vh - 241px)"
              }
              ref={updatedTicketGridRef}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              // onContentReady={updateDisplayedTicketCount}
              showColumnHeaders={false}
              // rowAlternationEnabled={true}
              showBorders={false}
              // focusedRowEnabled={true}
              keyExpr="__key"
              onRowClick={(e) => {
                if (!e?.data) return;

                const ticketCode = e.data.ticketcode;

                sessionStorage.setItem("lastOpenedTicket", ticketCode);
                sessionStorage.setItem("ticketNavSource", "details");
                sessionStorage.setItem("lastPageIndex", pageIndex);
                hasFocusedRef.current = false;

                navigate("/ticket/Details-of-Ticket", {
                  state: { detailData: e.data, from: "Tickets" },
                });
              }}
              onExporting={onExporting}
              onOptionChanged={(e) => {
                if (e.fullName === "searchPanel.text") {
                  handleSearchDebounce(e.value);
                }
                if (e.fullName === "paging.pageIndex") {
                  setPageIndex(e.value);
                }
              }}
            >
              {/* <Export enabled={true} /> */}
              <Selection mode="multiple" showCheckBoxesMode="always" />
              {isFilterMode && (
                <>
                  <Paging pageSize={pageSize} />
                  <Pager
                    visible={true}
                    showPageSizeSelector={false}
                    showInfo={true}
                    showNavigationButtons={true}
                  />
                </>
              )}
              {!isFilterMode && <Paging enabled={false} />}
              <Scrolling mode="standard" />{" "}
              <Toolbar>
                <Item location="before">
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>
                    {!isFilterMode && (
                      <SubText
                        text={ticketDataSource && `Total ${totalCount} tickets`}
                      />
                    )}

                    {isFilterMode && (
                      <SubText
                        text={
                          ticketDataSource &&
                          `Total ${displayedTicketCount} tickets`
                        }
                      />
                    )}
                  </div>
                </Item>
                <Item location="after">
                  <DropDownBox
                    showClearButton
                    stylingMode="outlined"
                    value={selectedSort}
                    dataSource={flatSortOptions}
                    valueExpr="id"
                    displayExpr="text"
                    placeholder="Sort by"
                    width={240}
                    onValueChanged={(e) => {
                      const value = e.value;

                      //  CLEAR CASE
                      if (!value) {
                        setSelectedSort("");
                        setSortConfig({ field: null, order: null });
                        return;
                      }

                      //  NORMAL SELECT (optional safety)
                      setSelectedSort(value);

                      const selected = flatSortOptions.find(
                        (i) => i.id === value,
                      );
                      if (selected) {
                        const [parentText, orderText] =
                          selected.text.split(" - ");

                        const parent = sortTicketData.find(
                          (p) => p.text === parentText,
                        );
                        const child = parent?.items?.find(
                          (c) => c.id === value,
                        );

                        if (child) {
                          setSortConfig({
                            field: child.field,
                            order: child.order,
                          });
                        }
                      }
                    }}
                    contentRender={() => (
                      <TreeView
                        items={sortTicketData}
                        dataStructure="tree"
                        keyExpr="id"
                        // parentIdExpr="categoryId"
                        itemsExpr="items"
                        displayExpr="text"
                        selectionMode="single"
                        selectByClick={true}
                        expandedItemKeys={expandedKeys} //  important
                        expandNodesRecursive={true}
                        // focusStateEnabled={false}
                        // activeStateEnabled={false}
                        // hoverStateEnabled={true}
                        onItemClick={handleSortClick}
                        itemRender={(item) => {
                          const isParent = item.items?.length;
                          const isExpanded = expandedKeys.includes(item.id);

                          return (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <span>{item.text}</span>

                              {isParent && (
                                <i
                                  className={
                                    isExpanded
                                      ? "ri-arrow-up-s-line"
                                      : "ri-arrow-down-s-line"
                                  }
                                  style={{ fontSize: "16px", color: "#6b7280" }}
                                ></i>
                              )}
                            </div>
                          );
                        }}
                      />
                    )}
                  />
                </Item>
                {/* {selectedSort && ( */}
                {/* <Item location={"after"} visible={selectedSort}>
                  <Button
                    text="Clear"
                    height={43}
                    // stylingMode="text"
                    stylingMode="outlined"
                    onClick={() => {
                      setSelectedSort("");
                      setSortConfig({ field: null, order: null }); //  instead of null
                    }}
                  />
                </Item> */}
                {/* )} */}
                <Item name="searchPanel" />
              </Toolbar>
              <SearchPanel visible={true} width={200} placeholder="Search" />
              <Column
                width={80}
                allowSearch={true}
                // caption="Ticket Subject"
                dataField="ticketsubject"
                cellRender={(cellData) => {
                  return (
                    <div className="cardAvatar">
                      {cellData.data.creator_logo ? (
                        <img
                          src={`data:image/png;base64,${cellData.data.creator_logo}`}
                          alt="creator"
                          className="noteAvatar"
                        />
                      ) : (
                        <div className="avatarFallback">
                          {cellData.data.ticketcreatedby
                            ?.charAt(0)
                            ?.toUpperCase() || "U"}
                        </div>
                      )}
                    </div>
                  );
                }}
              />
              <Column
                width={320}
                allowSearch={true}
                dataField="ticketsubject"
                cellRender={(cellData) => {
                  const tooltipId = `subInfo-${cellData.data.transid}`;
                  const grid = updatedTicketGridRef.current?.instance;

                  const currentPage = isFilterMode
                    ? (grid?.pageIndex?.() ?? 0)
                    : pageIndex;

                  const baseCount = isFilterMode
                    ? displayedTicketCount
                    : totalCount;

                  const srNo =
                    baseCount - (currentPage * pageSize + cellData.rowIndex);

                  return (
                    <div
                      className={`ticketInfoCol ${getRowClass(cellData.data.ticketcode)}`}
                    >
                      <div className="cardInfo">
                        <div
                          className={`ticketAgeStatus ${cellData.data.ticketworkflow
                            ?.toLowerCase()
                            .replace(/\s+/g, "-")}`}
                        >
                          {cellData.data.ticketworkflow}
                        </div>

                        <div className="cardSubject">
                          <span>#{srNo > 0 ? srNo : ""}</span>

                          <span className="subjectText" id={tooltipId}>
                            {cellData.data.ticketsubject}
                          </span>

                          <Tooltip
                            target={`#${tooltipId}`}
                            showEvent="mouseenter"
                            hideEvent="mouseleave"
                            position="top"
                          >
                            {cellData.data.ticketsubject}
                          </Tooltip>
                        </div>

                        <span className="ticketCreator">
                          <span style={{ fontWeight: 600 }}>
                            {cellData?.data?.ticketcode}
                          </span>

                          <span className="ticketDate">
                            {cellData.data.entry_date}
                          </span>
                        </span>

                        <div className="ticketTags">
                          {cellData.data.tags?.map((tag, index) => (
                            <span key={index} className="tagItem">
                              #{tag}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="ticketpriority_name"
                cellRender={({ data }) => (
                  <div className="cardPriorityStatus">
                    {/* Priority */}
                    <div className="priority">
                      <span
                        className={`priorityBox ${data.ticketpriority_name?.toLowerCase()}`}
                      ></span>
                      <span>{data.ticketpriority_name}</span>
                    </div>

                    {/* Status */}
                    <div
                      className={`status ${data.ticketstatus_name
                        ?.toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      {/* <i className="ri-loader-4-line statusIcon"></i> */}

                      <span>{data.ticketstatus_name}</span>
                    </div>
                    {/* ticketType */}
                    <div className="ticket-type">
                      <span>{data.tickettypename}</span>
                    </div>
                  </div>
                )}
              />
              {/* Priority */}
              <Column
                // alignment={"center"}
                // caption="Ticket Code"
                dataField="ticketcode"
                cellRender={({ data }) => (
                  <div className="cardStatus">
                    <div className="cardSubject">
                      <span style={{ fontWeight: 600 }}>
                        Created By : {data.ticketcreatedby}
                      </span>
                    </div>
                    <div className="workingUser">
                      <i className="ri-user-line userIcon"></i>
                      {data?.assigned_developer?.developer_name
                        ? `${data?.assigned_developer?.developer_name} (Support)`
                        : "-"}
                    </div>
                    <div className="lastResponse">
                      Last response: {data.last_replay}
                    </div>
                  </div>
                )}
              />
              <Column dataField="ticketworkflow" visible={false} />
              <Column dataField="last_replay" visible={false} />
              <Column dataField="developer_name" visible={false} />
              <Column dataField="search_type" visible={false} />
              <Column dataField="tickettypename" visible={false} />
              <Column dataField="tags" visible={false} />
              <Column dataField="ticketstatus_name" visible={false} />
            </DataGrid>
            {!isFilterMode && totalCount > 0 && (
              <div className="customPager">
                <button
                  className="pager-btn"
                  disabled={pageIndex === 0}
                  onClick={() => setPageIndex(pageIndex - 1)}
                >
                  <i className="ri-arrow-left-s-line"></i>
                </button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    className={pageIndex === i ? "activePage" : ""}
                    onClick={() => setPageIndex(i)}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  className="pager-btn"
                  disabled={pageIndex === totalPages - 1}
                  onClick={() => setPageIndex(pageIndex + 1)}
                >
                  <i className="ri-arrow-right-s-line"></i>
                </button>
              </div>
            )}
          </div>
          <div className={`filterPanel ${showFilterPanel ? "open" : ""}`}>
            <div className="filterHeader">
              <span
                style={{ display: "flex", gap: "4px" }}
                className="leftSectionFilterHeader"
              >
                <i className="ri-filter-3-line"></i>Filter
              </span>
              <div className="rightSectionFilterHeader">
                <Button text="Reset" type="default" onClick={resetFilters} />
                {/* <i
                  className="ri-close-line"
                  onClick={() => setShowFilterPanel(false)}
                ></i> */}
              </div>
            </div>

            <div className="filterBody">
              <div className="filterField">
                <label className="filterLabel">From Date</label>

                <DateBox
                  placeholder="Select Date"
                  type="date"
                  value={fromDate}
                  pickerType="calendar"
                  displayFormat="dd/MM/yyyy"
                  max={new Date()}
                  onValueChanged={(e) => setFromDate(e.value)}
                  disabled={timeRange}
                />
              </div>
              <div className="filterField">
                <label className="filterLabel">To Date</label>

                <DateBox
                  placeholder="Select Date"
                  type="date"
                  value={toDate}
                  pickerType="calendar"
                  displayFormat="dd/MM/yyyy"
                  max={new Date()}
                  min={new Date(fromDate)}
                  onValueChanged={(e) => setToDate(e.value)}
                  disabled={timeRange}
                />
              </div>

              <div className="filterField">
                <label className="filterLabel">Last Hours Filter</label>

                <SelectBox
                  items={[
                    { text: "last 12 hours", value: 12 },
                    { text: "last 24 hours", value: 24 },
                    { text: "last 36 hours", value: 36 },
                    { text: "last 48 hours", value: 48 },
                  ]}
                  valueExpr="value"
                  displayExpr="text"
                  value={timeRange}
                  // dropDownButtonRender={renderDropDownButton}
                  // itemRender={renderStatusItem}
                  onValueChanged={(e) => setTimeRange(e.value)}
                  disabled={fromDate || toDate}
                />
              </div>

              {showCustomerSelect && (
                <div className="filterField">
                  <label className="filterLabel">Client</label>
                  <SelectBox
                    items={customerList}
                    valueExpr="transid"
                    displayExpr="custname"
                    searchEnabled={true}
                    // showClearButton
                    value={selectedCustFilter}
                    onValueChanged={(e) => setSelectedCustFilter(e.value)}
                  />
                </div>
              )}

              <div className="filterField">
                <label className="filterLabel">Status</label>

                <SelectBox
                  items={statusOptions}
                  valueExpr="value"
                  displayExpr="text"
                  value={tempStatus}
                  dropDownButtonRender={renderDropDownButton}
                  itemRender={renderStatusItem}
                  onValueChanged={(e) => setTempStatus(e.value)}
                />
              </div>
              <div className="filterField">
                <label className="filterLabel">Priority</label>

                <SelectBox
                  items={priorityOptions}
                  // items={priorityList}
                  value={tempPriority}
                  valueExpr="value"
                  displayExpr="text"
                  itemRender={renderPriorityItem}
                  dropDownButtonRender={renderPriorityDropDownButton}
                  onValueChanged={(e) => setTempPriority(e.value)}
                />
              </div>
              <div className="filterField">
                <label className="filterLabel">Ticket Work Flow</label>
                <SelectBox
                  items={ticketWfOption}
                  value={ticketWf}
                  valueExpr="value"
                  displayExpr="text"
                  // itemRender={renderPriorityItem}
                  // dropDownButtonRender={renderPriorityButton}
                  onValueChanged={(e) => setTicketWf(e.value)}
                />
              </div>
              <div className="filterField">
                <label className="filterLabel">Type of Query</label>
                <SelectBox
                  items={ticketTypeOptions}
                  value={typeOfTicket}
                  valueExpr="value"
                  displayExpr="text"
                  // itemRender={renderPriorityItem}
                  // dropDownButtonRender={renderPriorityButton}
                  onValueChanged={(e) => setTypeOfTicket(e.value)}
                />
              </div>

              <div className="filterField">
                <label className="filterLabel">Developers Include</label>

                <SelectBox
                  items={agentOptions}
                  valueExpr="value"
                  displayExpr="text"
                  value={tempUser}
                  onValueChanged={(e) => setTempUser(e.value)}
                />
              </div>
              <div className="filterField">
                <label className="filterLabel">Tag</label>

                <SelectBox
                  // items={tagOptions}
                  items={tagOptions}
                  valueExpr="value"
                  displayExpr="text"
                  // searchExpr="text"
                  // searchMode="startswith"
                  value={tempTag}
                  searchEnabled={true}
                  // minSearchLength={1}
                  // showDataBeforeSearch={false}
                  placeholder="Type tag name"
                  onValueChanged={(e) => setTempTag(e.value)}
                />
              </div>

              <div className="myTicketCheckbox">
                <input
                  type="checkbox"
                  checked={tempOnlyMyTickets}
                  onChange={(e) => setTempOnlyMyTickets(e.target.checked)}
                />
                <span>Tickets I have created</span>
              </div>
            </div>
            <div className="filterBtnCont">
              <Button
                text="Apply"
                type="default"
                stylingMode="contained"
                width="291"
                onClick={applyFilters}
                disabled={!isApplyEnabled}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Popup for saving Ticket */}
      <Popup
        visible={createTicketPopup}
        onHiding={() => {
          showCreateTicketPopup(false);
          setTicketForm({
            subject: "",
            description: "",
            priority: "",
            category: "",
            subcategory: "",
            customer: "",
            contact: "",
            type: "",
            tags: [],
          });
          editorRef.current?.instance?.option("value", "");
          setAttachedFiles([]);
          setFilteredSubcategories([]);
        }}
        dragEnabled={false}
        showTitle={false}
        width={600}
        maxWidth="95vw"
        height="auto"
      >
        <div className="createTicketMainContainer">
          <div className="createTicketPopupContent">
            {/* HEADER */}
            <div className="popupHeader">
              <span className="headerText">Create New Ticket</span>
              <Button
                className="closeButton"
                stylingMode="text"
                icon="close"
                onClick={handleCreateTicketClosePopup}
              />
            </div>

            <div className="popupFieldContainer">
              {/* Customer SelectBox */}
              {showCustomerSelect && (
                <SelectBox
                  label="Select Client"
                  items={custOptions}
                  valueExpr="transid"
                  displayExpr="custname"
                  stylingMode="outlined"
                  searchEnabled={true}
                  showClearButton
                  value={ticketForm?.customer}
                  onValueChanged={(e) => handleChange("customer", e.value)}
                />
              )}

              {/* Contact SelectBox */}
              {showContactSelect && (
                <SelectBox
                  label="Select Contact"
                  stylingMode="outlined"
                  items={contactsByCompany}
                  valueExpr="contacttransid"
                  displayExpr="contactname"
                  searchEnabled={true}
                  showClearButton
                  value={ticketForm?.contact}
                  onValueChanged={(e) => handleChange("contact", e.value)}
                  disabled={!customerId}
                />
              )}

              {/* SUBJECT */}
              <div className="popupField">
                <TextBox
                  placeholder="Subject"
                  value={ticketForm.subject}
                  stylingMode="underlined"
                  onValueChanged={(e) => handleChange("subject", e.value)}
                />
              </div>

              {/* DESCRIPTION */}
              <div className="popupField">
                {/* <HtmlEditor
                  stylingMode="underlined"
                  height={190}
                  placeholder="Description"
                  value={ticketForm.description}
                  onValueChanged={handleDescriptionChange}
                > */}

                <HtmlEditor
                  ref={editorRef}
                  stylingMode="underlined"
                  height={190}
                  placeholder="Description"
                >
                  <Toolbar items={editorToolbarItems} />
                </HtmlEditor>
                {/* <div className="attachedFilesContainer">
                  <span className="attachedFilesLabel">File Attached :</span>
                  {attachedFiles.length === 0 ? (
                    <span className="noFile">None</span>
                  ) : (
                    attachedFiles.map((file, index) => (
                      <div key={index} className="attachedFileItem">
                        <span className="fileName">{file.name}</span>

                        <i
                          className="ri-close-line removeFileIcon"
                          onClick={() => removeFile(index)}
                        ></i>
                      </div>
                    ))
                  )}
                </div> */}
                <div className="attachedFilesContainer">
                  {/* <span className="attachedFilesLabel">File Attached :</span> */}

                  <div className="attachedFilesList">
                    <div className="fileLimitInfo">
                      <i id="fileInfoIcon" className="dx-icon dx-icon-info"></i>

                      <Tooltip
                        target="#fileInfoIcon"
                        showEvent="mouseenter click"
                        hideEvent="mouseleave"
                        position="top"
                      >
                        <div className="fileLimitTooltip">
                          Allowed: JPG, PNG, PDF, DOC, DOCX, TXT, XLSX, MP4{" "}
                          <br />
                          Max total size: 25 MB
                        </div>
                      </Tooltip>
                    </div>
                    {attachedFiles.length === 0
                      ? ""
                      : // <span className="noFile">No files</span>
                        attachedFiles.map((file, index) => (
                          <div key={index} className="attachedFileItem">
                            <span className="fileName">{file.name}</span>

                            <i
                              className="ri-close-line removeFileIcon"
                              onClick={() => removeFile(index)}
                            />
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="selectBoxBelowContainer">
              <div className="selectboxRow">
                <TagBox
                  className="tagboxScroll"
                  height={51}
                  label="Tag"
                  stylingMode="outlined"
                  items={tagList}
                  valueExpr="tagid"
                  displayExpr="tagname"
                  value={ticketForm.tags}
                  onValueChanged={(e) => handleChange("tags", e.value)}
                  showSelectionControls={true}
                >
                  {/* <Validator>
                  <RequiredRule message="Branch is required" />
                </Validator> */}
                </TagBox>
                <SelectBox
                  label="Type Of Query"
                  items={ticketTypeOptionsCn}
                  stylingMode="outlined"
                  valueExpr="value"
                  displayExpr="text"
                  value={ticketForm.type}
                  onValueChanged={(e) => handleChange("type", e.value)}
                />
              </div>
              <div className="selectboxRow">
                <SelectBox
                  label="Select Priority"
                  // items={priorityOptions}
                  items={priorityOptionCn}
                  value={ticketForm.priority}
                  valueExpr="value"
                  displayExpr="text"
                  stylingMode="outlined"
                  onValueChanged={(e) => handleChange("priority", e.value)}
                  itemRender={renderPriorityItem}
                  dropDownButtonRender={renderPriorityButton}
                />

                {/* CATEGORY */}

                <div className="popupField">
                  <SelectBox
                    label="Category"
                    stylingMode="outlined"
                    items={categoryOptions}
                    valueExpr="value"
                    displayExpr="text"
                    value={ticketForm.category}
                    onValueChanged={(e) => handleChange("category", e.value)}
                    disabled={!customerId}
                  />
                </div>

                {/* SUB CATEGORY */}

                <div className="popupField">
                  <SelectBox
                    label="Sub-Category"
                    stylingMode="outlined"
                    items={filteredSubcategories}
                    valueExpr="value"
                    displayExpr="text"
                    disabled={!ticketForm?.category}
                    value={ticketForm.subcategory}
                    onValueChanged={(e) => handleChange("subcategory", e.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="popupButton">
            <Button
              height={35}
              text="Create"
              type="default"
              stylingMode="contained"
              onClick={handleCreateTicket}
            />
          </div>
        </div>
      </Popup>

      {/* Uploaded Files */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
        multiple
      />
    </>
  );
}
